import React from 'react'
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router'
import { selectLangObj } from '../../reducers/langReducer';

export default function MoreInfo({moreTitle, moreLink}) {


    const langObj = useSelector(selectLangObj);

    return (
        <NavLink to={moreLink||"/Grid"} end className="text-blue-950 font-semibold">
            {moreTitle||langObj["SeeMore"]} 
        </NavLink>)
}
